import { dropdownHasValue, exceptionFormat, omit } from './utils'
import countCharsWithoutMask from './utils/count-chars-without-mask'
import { first, get, isEmpty, cloneDeep, isNil, camelCase, set, sortBy, isNull } from 'lodash'
import { FIELD_PROPS, FIELD_REQUIRED_LEVELS, GET_DATA_FIELD_PROPS } from './consts'

const VALUE_KEY = 'VALUE'
export const FIELDS_RE = /(Fields)\.([\w]*)\.([\w]*)/g
export const QUERIES_RE = /(Queries\.)([\w]+\((.*?)\))(\.{0,1}[\w]*)/g
export const FIELD_NEW_RE = /(field\()( *(["']\S*?["'])? *(, *(["']\S*?["']))? *(, *\d* *)? *(\)))/g
export const FIELD_FUNCTION_TWO_GROUP_RE = /field\(['"](\w+)['"](?:,\s*['"](\w+)['"]\))?/g // @regex field('mezonev', 'prop') -bol 2 groupba matchol
export const FIELDS_TWO_GROUP_RE = /Fields\.([\w]*)\.([\w]*)/g // @regex Fields.mezonev.prop -bol 2 groupba matchol
export const QUERIES_NEW_RE = /((query\()\s*(["'].*?["']){1}\s*,\s*(\[*[\w,\s"']*\]*)\s*,?\s*(["'].*?["'])?\s*\))/g // @regex match new query() function and parameters (multiline)
export const LOCATION_RE = /(location\(\))/g // @regex matches "location()" in string
export const EXPRESSION_OLD_FORMAT = '@oldFormat'
export const IS_ARRAY_RE = /[[\]]/ //ha stringkent kapunk tombot
export const OLD_FORMAT_RE = /\s*\/\*@oldFormat\*\/\s*/g // @regex oldFormat annotaciora matchol
export const EXPRESSION_NEW_FORMAT = '@newFormat' // @regex newFormat annotaciora matchol

const SUBFORM_ID_FIELD = 'ID'

export const formType = {
  DYNFORM: 'DynForm',
  FORM_VIEW: 'FormView',
  FORM_DATA_VERSION: 'FormDataVersion',
  HELPY_FORM: 'HelpyForm',
}
export const dateFields = ['date', 'time', 'datetime', 'datetime-local']

export const withRelatedTale = ['checkboxlist', 'radiobuttonlist', 'sqlchoosen', 'dropdownlist', 'multiselect']

export const getPropToChange = (expressionType) => {
  switch (expressionType) {
    case 'hiddenExp':
      return 'hidden'
    case 'readOnlyExp':
      return 'readOnly'
    case 'labelExp':
      return 'label'
    case 'listExp':
      return 'list'
    case 'filterExp':
      return 'list' //@TODO:filterExp jelenleg az expressionMap 'list' propToChange-be rakja a filterExp-et is
    case 'requiredExp':
      return 'required'
    default:
      return 'value'
  }
}

const omitFields = ['onlyleaf', 'dbType', 'posSizey', 'posRow', 'posCol', 'inputOptions']

const expressionProperties = [
  'filterExp',
  'labelExp',
  'readOnlyExp',
  'hiddenExp',
  'listExp',
  'requiredExp',
  'defaultValue',
  'mapDefaultAddressExp',
]

const exceptionFormatRule = ['status', 'sqlchoosen', 'checkboxlist', 'dropdownlist', 'multiselect', 'wpaint']

const groupExpressionProperties = ['hiddenExp', 'readOnlyExp', 'labelExp', 'collapsedExp']
const pageExpressionProperties = ['hiddenExp', 'readOnlyExp', 'labelExp']
const formExpressionProperties = ['hiddenExp', 'readOnlyExp']

/**
 * @description A lekérdezett formstructure-t összefésüli a datával, valamint kigyűjti az expressionöket.
 * @param forms
 * @param data
 * @return {*}
 */
export function createForm(forms, data) {
  let _forms = cloneDeep(forms)
  return _forms.reduce((accu, form) => {
    const pathByName = {}
    let queryExpressions = new Set()
    const mainFormFields = new Set()
    let saveExpression = new Set()
    let idMainTableField = null

    if (!form.tags) form.tags = []
    form.readOnly = get(data, 'FORM.READ_ONLY', get(form, 'readOnly', false))
    if (form.readOnly) form.readOnlyExp = {}

    if (form.saveExpression && form.saveExpression.exp) {
      const matches = parseExpression(form.saveExpression.exp)
      ;[...matches].forEach((exp) =>
        saveExpression.add(
          Object.assign({}, exp, {
            subform: false,
            subformIndex: 0,
          })
        )
      )
      const saveQueryExpression = createQueryExpression(form.saveExpression.exp)
      queryExpressions = new Set([...saveQueryExpression])
      saveExpression = new Set([...saveExpression])
    }

    if ((form.readOnlyExp && form.readOnlyExp.exp) || (form.hiddenExp && form.hiddenExp.exp)) {
      formExpressionProperties.forEach((prop) => {
        const expression = get(form, `${prop}.exp`, false)
        if (expression) {
          const formQueryExressions = createQueryExpression(expression)
          queryExpressions = new Set([...queryExpressions, ...formQueryExressions])
        }
      })
    }

    const idMainTableName = `ID_${form.mainTable}`
    form.pages = Object.values(form.pages).map((page, pid) => {
      page.readOnly = !!get(data, `['PAGES'][${page.id}][READ_ONLY]`, false)
      page.hidden = !!get(data, `['PAGES'][${page.id}][HIDDEN]`, false)

      pageExpressionProperties.forEach((prop) => {
        const expression = page[prop] && page[prop].exp ? page[prop].exp : ''
        const formQueryExressions = createQueryExpression(expression)
        queryExpressions = new Set([...queryExpressions, ...formQueryExressions])
      })

      page.groups = Object.values(page.groups).map((group, gid) => {
        groupExpressionProperties.forEach((prop) => {
          const expression = group[prop] && group[prop].exp ? group[prop].exp : ''
          const groupQueryExressions = createQueryExpression(expression)
          queryExpressions = new Set([...queryExpressions, ...groupQueryExressions])
          pathByName[group.id] = { pid, gid }
        })

        const rowFields = Object.values(group.items).sort((item1, item2) => {
          return item1.posCol < item2.posCol ? -1 : item1.posCol > item2.posCol ? 1 : 0
        })

        group.collapsed = get(data, `['F_GROUPS'][${group.id}][COLLAPSED]`, false)
        group.readOnly = !!get(data, `['F_GROUPS'][${group.id}][READ_ONLY]`, false)
        group.hidden = get(data, `['F_GROUPS'][${group.id}][HIDDEN]`, 0)

        group.rows =
          rowFields.reduce((rows, item) => {
            if (item.name === idMainTableName) {
              idMainTableField = item.id
            }
            normalizeFields(item)
            extendWithRequired(item, data.ITEMS)
            if (isSubForm(item)) {
              item.subForm = createSubForm(item, data)
            } else {
              mainFormFields.add(item.name)
            }
            const rowIndex = item.posRow
            rows[rowIndex] = rows[rowIndex] || []
            const originalItem = data.ITEMS[item.id] || {}
            item = extendWithValue(item, originalItem)
            item = omit(item, omitFields)
            if (isSingleselecgtSQLChoosen(item)) {
              const hasValue = dropdownHasValue(item.value)
              item.value = hasValue ? (Array.isArray(item.value) ? item.value : [item.value]) : []
            }
            if (isCameras(item) && item.value)
              item.value = Array.isArray(item.value) ? item.value : item.value.split(',')

            if (item) {
              rows[rowIndex].push(item)
              let itemIdx = rows[rowIndex].indexOf(item)
              pathByName[item.name] = { pid, gid, rid: rowIndex, fid: itemIdx }
              const itemPath = `${pid}/${gid}/${rowIndex}/${itemIdx}`

              /**
               * kiemeltuk kulon fuggvenybe, amit itt akar haromszor is meg kellene hivni
               * @param item
               * @param key
               * @param exp
               */
              const createItemExpressions = function (item, key, exp) {
                const itemQueryExressions = createQueryExpression(exp)
                queryExpressions = new Set([...queryExpressions, ...itemQueryExressions])
              }

              Object.entries(item).forEach(([key, value]) => {
                if (key === 'formats') {
                  ;['maxExp.exp', 'minExp.exp'].forEach((path) => {
                    const formatExp = get(value, path)
                    if (formatExp) createItemExpressions(item.name, path, formatExp)
                  })
                }
                if (expressionProperties.includes(key) && get(value, 'type') === 'exp') {
                  createItemExpressions(item.name, key, value.exp)
                }
              })

              if (item.subForm) {
                if (item.subForm.queryExpressions && [...item.subForm.queryExpressions].length) {
                  queryExpressions = new Set([...queryExpressions, ...item.subForm.queryExpressions])
                }
              }
            }
            return rows
          }, []) || []
        delete group.items
        return group
      })
      return page
    })
    form.pathByName = pathByName
    form.mainFormFields = mainFormFields
    form.queryExpressions = queryExpressions
    form.saveExpression = saveExpression
    form.idMainTableField = idMainTableField
    return Object.assign(accu, form)
  }, {})
}

export function normalizeFields(item) {
  item.value = isMultiSelect(item) ? [] : null

  item.errors = []
  item.placeholder = item.formats?.placeholder || item.inputOptions?.placeholder || item.placeholder || ''

  if (item.read_only) item.readOnly = true
  if ((item.HIDDEN && item.hidden === 1) || (item.hidden && item.hidden === 1)) item.hidden = 1

  item.validations = {}
  if (item.formats) {
    if (isNull(item.requiredExp) && item.formats.required) {
      item.validations.required = item.formats.required
    }
    if (dateFields.includes(item.type)) {
      if (item.type === 'time') {
        if (item.formats.min) {
          item.formats.min = new Date().setHours(item.formats.min.split(':')[0], item.formats.min.split(':')[1])
        }
        if (item.formats.max) {
          item.formats.max = new Date().setHours(item.formats.max.split(':')[0], item.formats.max.split(':')[1])
        }
      } else {
        if (item.formats.min) item.formats.min = new Date(item.formats.min).getTime()
        if (item.formats.max) item.formats.max = new Date(item.formats.max).getTime()
      }
    }
    if (item.formats.min !== undefined && item.formats.min !== null) item.validations.min_value = item.formats.min
    if (item.formats.max !== undefined && item.formats.max !== null) item.validations.max_value = item.formats.max
    if (exceptionFormat(exceptionFormatRule, item.type) && item.formats.minlength)
      item.validations.min = item.formats.minlength // kivételeken a minlengtn nem használható
    if (exceptionFormat(exceptionFormatRule, item.type) && item.formats.maxlength)
      item.validations.max = item.formats.maxlength // kivételeken a maxlengtn nem használható
    if (item.formats.decimal) item.validations.decimal = item.formats.decimal
    if (item.formats.directInputEntry) item.directInputEntry = item.formats.directInputEntry
    if (item.formats.mimeTypes) item.mimeTypes = item.formats.mimeTypes
    if (item.formats.maxFileSize) item.maxFileSize = item.formats.maxFileSize
    if (item.formats.maxFileSizeInteger) item.maxFileSizeInteger = item.formats.maxFileSizeInteger
    if (item.formats.acceptedExtensions) item.acceptedExtensions = item.formats.acceptedExtensions
    if (item.formats.suffix) item.suffix = item.formats.suffix
    if (item.formats.prefix) item.prefix = item.formats.prefix
    if (isEmail(item)) item.validations.email = true
    if (!isNil(item.formats.pattern) && typeof item.formats.pattern !== typeof undefined) {
      let pattern = item.formats.pattern
      if (IS_ARRAY_RE.test(item.formats.pattern)) {
        item.formats.pattern = item.formats.pattern.replace(/'/g, '"') //ki kell cserelni az idezojeleket, ha stringben jon a tomb
        pattern = JSON.parse(item.formats.pattern)
      }
      const patternProps = countCharsWithoutMask(pattern)
      item.validations.fakeLength = {
        min: patternProps.min,
        fakeMin: patternProps.fakeMin,
        fakeMax: patternProps.fakeMax,
        field: item.id,
      }
      item.validations.max = patternProps.max
    }
    if (isNumber(item) && item.formats.minlength) {
      item.formats.min = item.formats.minlength
    }

    if (item.dbType === 'number' && item.validations.decimal) {
      let digit = item.validations.max
      item.validations.floatNumber = {
        digit,
        decimal: item.validations.decimal,
        field: item.id,
      }
      delete item.validations.decimal
    }
  }

  if (item.type === 'captcha') {
    item.validations.required = FIELD_REQUIRED_LEVELS.ERROR
  }

  return item
}

export function extendWithRequired(item, data) {
  const errorLevel = get(data, [item.id, GET_DATA_FIELD_PROPS.REQUIRED])
  if ([FIELD_REQUIRED_LEVELS.WARNING, FIELD_REQUIRED_LEVELS.ERROR].includes(errorLevel)) {
    const validations = get(item, FIELD_PROPS.VALIDATIONS, {})
    item.validations = Object.assign(validations, { required: errorLevel })
  }
}

export function extendWithFormattedValue({ VALUE: value, LIST: list }) {
  const formattedValue = []
  const valueArray = Array.isArray(value) ? value : [value]
  for (const key of valueArray) {
    const selectedOption = list.options.find((option) => String(option.key) === String(key))
    if (selectedOption && selectedOption.value) {
      formattedValue.push(selectedOption.value)
    }
  }
  return formattedValue.join(', ')
}

export function castValueTypeToMatchKeyType(option, value) {
  const isArray = Array.isArray(value)
  value = isArray ? value : [value]
  const keyType = typeof option.key
  const valueType = typeof first(value)
  if (keyType !== valueType) {
    if (keyType === 'string') {
      return value.map((key) => String(key))
    }
    if (keyType === 'number') {
      return value.map((key) => Number(key))
    }
  }
  return value
}

export function extendWithValue(item, data) {
  Object.entries(data).forEach(([key, value]) => {
    const lowerKey = camelCase(String(key))
    item[lowerKey] = value
  })
  if (data.hasOwnProperty('LIST') && dropdownHasValue(data.VALUE) && Array.isArray(data.LIST)) {
    const options = get(data, 'LIST.options', get(data, 'LIST'), [])
    const value = get(data, 'VALUE')
    item.value = castValueTypeToMatchKeyType(first(options), value)
  }
  return item
}

export function toSubFormField2(item) {
  let field = normalizeFields(item)
  field = omit(field, omitFields)
  return field
}

export function parseExpression(expression, type) {
  if (typeof expression === 'object' && expression.hasOwnProperty('exp')) expression = expression.exp
  if (isNil(expression) || isEmpty(expression)) return []
  let matches = []
  let parsed = new Set()

  if (expression.includes(EXPRESSION_OLD_FORMAT)) {
    matches = expression.match(FIELDS_RE)
  } else {
    matches = expression.match(FIELD_NEW_RE)
  }

  if (Array.isArray(matches) && matches.length) {
    matches.forEach((match) => {
      let name, prop
      if (expression.includes(EXPRESSION_OLD_FORMAT)) {
        ;[name, prop] = match.replace('Fields.', '').split('.')
      } else {
        match = match
          .replace('field(', '')
          .replace(')', '')
          .replace(/"|'|\s+/g, '')
        const sliced = match.split(',')
        name = sliced[0]
        prop = sliced[1] ? sliced[1] : 'value'
      }

      parsed.add({
        expression: expression,
        watchName: name,
        watchProp: prop,
        expressionType: type,
      })
    })
  } else {
    parsed.add({
      expression: expression,
      watchName: '',
      watchProp: '',
      expressionType: type,
    })
  }
  return parsed
}

export function prepareQuery(exp) {
  if (typeof exp !== 'string') return exp

  let matches
  if (exp.includes(EXPRESSION_OLD_FORMAT)) {
    while ((matches = QUERIES_RE.exec(exp))) {
      if (matches[4]) {
        exp = exp.replace(matches[0], `(async () => { return (await ${matches[1]}${matches[2]})${matches[4]} })();`)
      } else {
        exp = `(async () => { return (await ${exp}).FULL_RESULT })();`
        break
      }
    }
  } else {
    const queryMatches = exp.match(QUERIES_NEW_RE) || []
    const locationMatches = exp.match(LOCATION_RE) || []
    matches = [...queryMatches, ...locationMatches]
    if (matches && matches.length) {
      matches.forEach((match) => {
        exp = exp.replace(match, `await ${match}`)
      })
    }
  }
  return exp
}

export function prepareExpression(exp, rowId = null) {
  if (typeof exp !== 'string') return exp

  if (exp.includes(EXPRESSION_OLD_FORMAT)) {
    return exp
  } else {
    return `(async () => { ${exp}; return getResult(); })();`
  }
}

export function createQueryExpression(expression) {
  const queryExp = new Set()
  let sqlMatch = null

  if (expression.includes(EXPRESSION_OLD_FORMAT)) {
    while ((sqlMatch = QUERIES_RE.exec(expression))) {
      let [, , name, , prop] = sqlMatch
      name = name.substring(0, name.indexOf('('))
      prop = prop.replace('.', '')
      queryExp.add({ name, prop })
    }
  } else {
    const matches = expression.match(QUERIES_NEW_RE)
    if (matches && matches.length) {
      matches.forEach((match) => {
        //Egysorossá alakítjuk és kivesszük a paramokat
        match = match
          .replace(/\s+/g, ' ') // @regex removes multiple consecutive whitespace characters and replaces them with a single space
          .trim()
          .replace(/\[.*?\]/, '')
        const paramList = match.replace('query(', '').replace(/\)$/gm, '').split(',')
        let name = paramList[0].replace(/"|'/g, '').trim()
        let prop = paramList[2] ? paramList[2].replace(/"|'/g, '').trim() : ''
        queryExp.add({ name, prop })
      })
    }
  }

  return queryExp
}

export function createSubForm(item, data = {}) {
  const subFormBuilderData = get(item, ['subFormBuilderData'], {})
  const items = [
    {
      id: 'ID',
      hidden: true,
      type: 'text',
      name: 'ID',
      value: null,
      itemSeq: 0,
      posRow: 0,
      posCol: 0,
    },
  ]
  let queryExpressions = new Set()
  Object.values(subFormBuilderData.pages).forEach((page) => {
    Object.values(page.groups).forEach((group) => {
      // a subForm leirojanak mezoi
      // @TODO full rekurzio eseten ujrairni a fieldek kikereseset tobb groupbol
      const sortedFieldSchemas = sortBy(Object.values(group.items), ['posRow', 'posCol'])
      //regi sort
      /*.sort((item1, item2) => item1.posRow < item2.posRow ? -1 : item1.posRow > item2.posRow ? 1 : 0)
              .sort((item1, item2) => item1.posCol < item2.posCol ? -1 : item1.posCol > item2.posCol ? 1 : 0)*/
      sortedFieldSchemas.forEach((fieldSchema) => items.push(fieldSchema))
    })
  })
  const responseData = cloneDeep(get(data, ['ITEMS', item.id, 'VALUE'], []))
  const subformData = []
  responseData.forEach((subFormRow) => {
    const subformRowMergedData = []
    items.forEach((fieldSchema) => {
      extendWithRequired(fieldSchema, subFormRow)
      if (subFormRow.hasOwnProperty(fieldSchema.id)) {
        const schemaClone = cloneDeep(fieldSchema)
        Object.entries(subFormRow[fieldSchema.id]).forEach(([dataKey, value]) => {
          set(schemaClone, camelCase(dataKey), value)
        })
        subformRowMergedData.push(schemaClone)
      }
    })
    subformData.push({ items: subformRowMergedData })
  })

  //const maintable = Object.values(item.subForm.forms)[0].mainTable || ''
  const heads = items.reduce((heads, field) => {
    if (!isEmpty(get(field, 'labelExp.exp', ''))) {
      heads.push({
        labelExp: field.labelExp,
        name: field.name,
      })
    } else {
      heads.push({
        label: field.label,
        name: field.name,
      })
    }
    return heads
  }, [])

  items.forEach((fieldSchema) => {
    // @TODO query-k lehetnenek a builderdataban ??
    Object.entries(fieldSchema).forEach(([key, value]) => {
      if (expressionProperties.includes(key)) {
        if (get(value, 'type') === 'exp') {
          const sfQueryExressions = createQueryExpression(value.exp)
          queryExpressions = new Set([...queryExpressions, ...sfQueryExressions])
        }
      }
    })
  })

  return {
    id: item.id,
    name: item.name,
    data,
    items,
    heads,
    queryExpressions,
    rows: subformData,
  }
}

export function refreshList(form, data) {
  form.pages.forEach((page) => {
    page.groups.forEach((group) => {
      group.rows.forEach((row) => {
        if (row) {
          row.forEach((field) => {
            if (field.list) {
              const itemData = data.ITEMS[field.id]
              if (itemData && itemData.LIST) {
                field.list = itemData.LIST
              }
            }
          })
        }
      })
    })
  })
  return form
}

export function refreshFields(form, data) {
  form.pages.forEach((page, pageIndex) => {
    let path = `${pageIndex}`
    page.groups.forEach((group, groupIndex) => {
      path += `/${groupIndex}`
      group.rows.forEach((row, rowIndex) => {
        path += `/${rowIndex}`
        if (row) {
          row.forEach((field, fieldIndex) => {
            path += `/${fieldIndex}`
            const newVal = get(data, `ITEMS.${field.name}.VALUE`, false)
            if (field && newVal) {
              this.$dispatch('updatePropByPath', { path, value: newVal })
            }
          })
        }
      })
    })
  })
}

export function isSelect(field) {
  return isDropDown(field) || isMultiSelect(field)
}

export function isBaseSelect(field) {
  return field.select ? field.select === 'base' : false
}

export function isSubForm(field) {
  return field.type === 'subform'
}

export function isMultiValue(field) {
  return isMultiSelect(field) || isCheckboxList(field)
}

export function isMultiSelect(field) {
  return ['multiselect', 'status'].includes(field.type) || field.multiple || field.taggable
}

export const isTaggable = (field) => field.taggable

export const isMultiselect = (field) => isSelect(field) && field.multiple

export const isScalar = (value) =>
  !Array.isArray(value) && (typeof value === 'number' || (typeof value === 'string' && value.length))

export function isSingleselecgtSQLChoosen(field) {
  return field.type === 'sqlchoosen' && !field.multiselect
}

export function isTextarea(field) {
  return field.type === 'textarea' || (field.type === 'richtext' && !field.formattedText)
}

export function isEmail(field) {
  return field.type === 'email'
}

export function isDate(field) {
  return ['date', 'date_interval', 'datetime', 'datetime_interval', 'time', 'time_interval', 'datetime-local'].includes(
    field.type
  )
}

export function isDropDown(field) {
  return field.type === 'dropdownlist'
}

export function isCheckbox(field) {
  return field.type === 'checkbox'
}

export function isSlider(field) {
  return field.type === 'slider'
}

export function isCheckboxList(field) {
  return field.type === 'checkboxlist'
}

export function isRadioList(field) {
  return field.type === 'radiobuttonlist'
}

export function isRange(field) {
  return field.type === 'range'
}

export function isChoiceList(field) {
  return isCheckboxList(field) || isRadioList(field)
}

export function isInfo(field) {
  return field.type === 'info'
}

export function isLabel(field) {
  return field.type === 'label'
}

export function isRating(field) {
  return field.type === 'rating'
}

export function isPaint(field) {
  return field.type === 'wpaint'
}

export function isSignature(field) {
  return field.type === 'signature'
}

export function isJSONEditor(field) {
  return field.type === 'jsoneditor'
}

export function isCameras(field) {
  return field.type === 'cameras'
}

export function isDocumentProp(field) {
  return field.type === 'document-prop'
}

export function isMap(field) {
  return field.type === 'map'
}

export function isGps(field) {
  return field.type === 'gps'
}

export function isNumber(field) {
  return field.type === 'number'
}

export function toDropDownList(list = {}) {
  return Object.entries(list || {}) // prepare for null
}

export function isNumberInterval(field) {
  return field.type === 'number_interval'
}

export function isUniversalFilter(field) {
  return field.type === 'universalFilter'
}

export function isRichText(field) {
  return field.type === 'richtext' && field.formattedText
}

export function isChecklist(field) {
  return field.type === 'checklist'
}

export function isPathfinder(field) {
  return field.type === 'pathfinder'
}

export function isSqlSelect(field) {
  return ['sqlchoosen', 'sqlselect', 'sqlselectlist'].includes(field.type)
}

export function isConditionBuilder(field) {
  return field.type === 'conditionBuilder'
}

export function isTaskExpressions(field) {
  return field.type === 'taskExpressions'
}

export function isExpressionEditor(field) {
  return field.type === 'expressioneditor'
}

export function isPasswordField(field) {
  return field.type === 'password'
}

export function isTextField(field) {
  return field.type === 'password' || field.type === 'text' || isTextarea(field) || isRichText(field)
}

export function isComment(field) {
  return field.type === 'comment'
}

export function isLink(field) {
  return field.type === 'link'
}

export function isTagField(field) {
  return field.type === 'tag'
}

export function isCaptcha(field) {
  return field.type === 'captcha'
}
